import { Deployment } from '@analyzer/client';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useService } from '../providers/ServiceProvider';

export function useDeploymentListQuery(
  projectId: string,
  testId: string,
  queryParams?: { limit?: number; offset?: number }
) {
  const client = useService();
  return useQuery<Deployment[], Error>(
    ['deployment-list', projectId, testId, queryParams],
    () => client.deploymentList(projectId, testId, queryParams),
    {
      keepPreviousData: true
    }
  );
}

export function useDeploymentReadQuery(projectId: string, deploymentId: string) {
  const client = useService();
  return useQuery<Deployment, Error>({
    queryKey: ['deployment-read', projectId],
    queryFn: () => client.deploymentRead(projectId, deploymentId)
  });
}

export function useDeploymentDestroyMutation(projectId: string, testId: string) {
  const client = useService();
  const queryClient = useQueryClient();

  return useMutation<boolean, Error, { deploymentId: string }>({
    mutationFn: ({ deploymentId }) => client.deploymentDestroy(projectId, deploymentId),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['deployment-list', projectId, testId] })
  });
}
